module.exports = __webpack_public_path__ + "img/Banner.ef84c269.svg";